import { get, isEmpty } from 'lodash';
import { translate } from '@fiverr-private/i18n-react';
import copies from '../../../copies';
import { extractKeyPaths } from '../../../utils/object';
import { MEANINGFUL_MESSAGE_MIN_THRESHOLD } from './constants';

const notMeaningful = (value, sellerName) => {
    if (isEmpty(value)) {return true;}

    const rawQuickQuestions = extractRawQuickQuestions(sellerName);

    rawQuickQuestions.forEach((rawQuickQuestion) => {
        const rawQuickQuestionRegex = new RegExp(rawQuickQuestion, 'g');

        value = value.replace(rawQuickQuestionRegex, '');
    });

    return value.trim().length >= MEANINGFUL_MESSAGE_MIN_THRESHOLD;
};

const extractRawQuickQuestions = (sellerName) => {
    const quickQuestionCopyRoot = 'send_message.quick_questions';
    const quickQuestionRoot = get(copies, quickQuestionCopyRoot, {});
    const quickQuestionKeyPaths = extractKeyPaths(quickQuestionRoot);
    const params = { sellerName };

    return quickQuestionKeyPaths.map((quickQuestionKeyPath) =>
        translate(`${quickQuestionCopyRoot}.${quickQuestionKeyPath}`,
            { params }
        )
    );
};

const extendedRules = {
    notMeaningful
};

export default extendedRules;
